import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Config } from '../../common/types/config';
import { Logger } from '../../common/types/loggerTypes';
import { createApiService } from '../../common/apiAdapters/apiService';
import { PartialLocationObject } from '../../server/types/bellaRequest';
import GaTracking from '../ga';
import rootReducer from './rootReducer';
import { MiddlewareDependencies } from './types';

export const createDependencies = (
    shopApiBaseUrl: string,
    config: Config,
    logger: Logger,
    country: string,
    userAgent: string,
    location: PartialLocationObject,
    ga?: GaTracking
    // eslint-disable-next-line max-params
) => {
    const apiService = createApiService(shopApiBaseUrl, config, country, userAgent, location);

    const dependencies: MiddlewareDependencies = { apiService, logger, ga };
    return dependencies;
};

/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-require-imports  */
export default function configureStore(initialState = {}, middlewareDependencies?: MiddlewareDependencies) {
    const anyWindow: any = typeof window === 'object' ? window : {};

    const composeEnhancers = anyWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? (anyWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) as typeof compose)
        : compose;

    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancers(applyMiddleware(thunkMiddleware.withExtraArgument(middlewareDependencies)))
    );

    if (middlewareDependencies) {
        middlewareDependencies.apiService.shopApi.setDispatch(store.dispatch);
    }

    // Code below should only be executed when HMR is on, i.e. dev env only
    if (module.hot) {
        module.hot.accept('./rootReducer', () => {
            // fetch the new state of reducers and apply it for the existing store
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const nextRootReducer = require('./rootReducer').default;
            anyWindow.__HMR_STORE__.replaceReducer(nextRootReducer);
        });

        if (typeof window === 'object') {
            // for HMR to work properly with redux we need to keep the same instance of a store object
            if (!anyWindow.__HMR_STORE__) {
                anyWindow.__HMR_STORE__ = store;
            }
            return anyWindow.__HMR_STORE__ as typeof store;
        }
    }

    return store;
}

export type BellaStore = ReturnType<typeof configureStore>;
export type BellaDispatch = BellaStore['dispatch'];
